import { render, staticRenderFns } from "./ProductSummary.vue?vue&type=template&id=3754078c&"
import script from "./ProductSummary.vue?vue&type=script&lang=js&"
export * from "./ProductSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports